import { render, staticRenderFns } from "./remitTeac.vue?vue&type=template&id=1cfae42b&scoped=true&"
import script from "./remitTeac.vue?vue&type=script&lang=js&"
export * from "./remitTeac.vue?vue&type=script&lang=js&"
import style0 from "./remitTeac.vue?vue&type=style&index=0&id=1cfae42b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfae42b",
  null
  
)

export default component.exports